// settings.js - App-level settings stored in Firestore
import { db } from '../firebaseConfig';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

const APP_SETTINGS_COLLECTION = 'appSettings';
const REWARDS_SETTINGS_DOC = 'rewards';
const REWARDS_OVERLAY_FIELD = 'comingSoonOverlayEnabled';

export const getRewardsComingSoonOverlayEnabled = async () => {
  try {
    const ref = doc(db, APP_SETTINGS_COLLECTION, REWARDS_SETTINGS_DOC);
    const snapshot = await getDoc(ref);

    if (!snapshot.exists()) {
      return false;
    }

    const data = snapshot.data();
    return Boolean(data?.[REWARDS_OVERLAY_FIELD]);
  } catch (error) {
    console.error('Error fetching rewards overlay setting:', error);
    return false;
  }
};

export const setRewardsComingSoonOverlayEnabled = async (enabled) => {
  const ref = doc(db, APP_SETTINGS_COLLECTION, REWARDS_SETTINGS_DOC);
  await setDoc(
    ref,
    {
      [REWARDS_OVERLAY_FIELD]: Boolean(enabled),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
};
